module.exports = __webpack_public_path__ + "media/images/flags/32/Cuba-1877f762d6a7810936dab99c7a11c88d.png";